/* Collider stockists page. Needs stockists-leaflet.js (Leaflet 1.9.4) and stockists-cluster.js
   (Leaflet.markercluster 1.5.3) loaded first. Falls back to plain pins if the cluster plugin is missing. */
(function () {
  'use strict'

  var root = document.getElementById('stockists-root')
  if (!root || typeof L === 'undefined') return

  var DATA_URL = root.getAttribute('data-stockists-url')
  var API = 'https://api.postcodes.io'
  var TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
  var ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  var FULL_PC = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/
  var OUTCODE = /^[A-Z]{1,2}\d[A-Z\d]?$/

  var listEl = document.getElementById('stk-list')
  var errEl = document.getElementById('stk-error')
  var form = document.getElementById('stk-search-form')
  var input = document.getElementById('stk-postcode')
  var tabs = Array.prototype.slice.call(root.querySelectorAll('.stk__tab'))

  var state = { all: [], filter: 'all', origin: null }
  var map = L.map('stk-map', { scrollWheelZoom: false })
  L.tileLayer(TILES, { attribution: ATTR, maxZoom: 19 }).addTo(map)
  map.setView([54.0, -2.5], 5)
  // Clusters at country/region zoom; individual pins from town level (zoom 12) in.
  var markerLayer = (L.markerClusterGroup
    ? L.markerClusterGroup({
        maxClusterRadius: 48,
        disableClusteringAtZoom: 12,
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: true,
        chunkedLoading: true,
        iconCreateFunction: clusterIcon
      })
    : L.layerGroup()).addTo(map)
  var originMarker = null
  var markersById = {}

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }

  function miles(a, b) {
    var R = 3958.761
    var dLat = ((b.lat - a.lat) * Math.PI) / 180
    var dLng = ((b.lng - a.lng) * Math.PI) / 180
    var la1 = (a.lat * Math.PI) / 180
    var la2 = (b.lat * Math.PI) / 180
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
    return 2 * R * Math.asin(Math.sqrt(h))
  }

  function pinIcon(type) {
    return L.divIcon({
      className: '',
      html: '<div class="stk-pin stk-pin--' + (type === 'retail' ? 'retail' : 'hospitality') + '"></div>',
      iconSize: [26, 26],
      iconAnchor: [13, 24],
      popupAnchor: [0, -22]
    })
  }

  // Cluster bubble takes the colour of its majority type; size steps with count.
  function clusterIcon(cluster) {
    var kids = cluster.getAllChildMarkers()
    var retail = 0
    kids.forEach(function (m) { if (m.options.stkType === 'retail') retail++ })
    var tone = retail * 2 >= kids.length ? 'retail' : 'hospitality'
    var n = cluster.getChildCount()
    var size = n < 10 ? 34 : n < 100 ? 40 : 46
    return L.divIcon({
      className: '',
      html: '<div class="stk-cluster stk-cluster--' + tone + '" style="width:' + size + 'px;height:' + size + 'px">' + n + '</div>',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2]
    })
  }

  function matchesFilter(s, f) {
    if (f === 'all') return true
    if (f === 'retail') return s.type === 'retail'
    if (f === 'supermarket' || f === 'independent') return s.type === 'retail' && s.retailType === f
    return s.type === f
  }

  function badgeLabel(s) {
    if (s.type !== 'retail') return 'Pub / restaurant'
    if (s.retailType === 'supermarket') return 'Supermarket'
    if (s.retailType === 'independent') return 'Independent retail'
    return 'Retail'
  }

  function directionsUrl(s) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng
  }

  function popupHtml(s) {
    var html = '<strong>' + esc(s.name) + '</strong><br>' + esc(s.address) + ', ' + esc(s.city) + ' ' + esc(s.postcode)
    html += '<br><a href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Directions</a>'
    if (s.website) html += ' &middot; <a href="' + esc(s.website) + '" target="_blank" rel="noopener">Website</a>'
    return html
  }

  function visible() {
    return state.all.filter(function (s) { return matchesFilter(s, state.filter) })
  }

  function cardHtml(s) {
    var badge = badgeLabel(s)
    var html = '<div class="stk-card__head"><h3 class="stk-card__name">' + esc(s.name) + '</h3>' +
      '<span class="stk-card__badge stk-card__badge--' + esc(s.type) + '">' + badge + '</span></div>' +
      '<p class="stk-card__addr">' + esc(s.address) + ', ' + esc(s.city) + ' ' + esc(s.postcode) + '</p>'
    if (s._miles != null) {
      html += '<p class="stk-card__dist">' + s._miles.toFixed(1) + ' miles away</p>'
    }
    html += '<div class="stk-card__links"><a href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Directions</a>'
    if (s.website) html += '<a href="' + esc(s.website) + '" target="_blank" rel="noopener">Website</a>'
    html += '</div>'
    return html
  }

  function render() {
    var rows = visible()
    rows.forEach(function (s) {
      s._miles = state.origin ? miles(state.origin, s) : null
    })
    rows.sort(function (a, b) {
      return state.origin ? a._miles - b._miles : a.name.localeCompare(b.name)
    })

    markerLayer.clearLayers()
    markersById = {}
    var markers = rows.map(function (s) {
      var m = L.marker([s.lat, s.lng], { icon: pinIcon(s.type), stkType: s.type }).bindPopup(popupHtml(s))
      markersById[s.id] = m
      return m
    })
    if (markerLayer.addLayers) markerLayer.addLayers(markers)
    else markers.forEach(function (m) { m.addTo(markerLayer) })

    listEl.innerHTML = ''
    if (rows.length === 0) {
      var empty = document.createElement('li')
      empty.className = 'stk__empty'
      empty.textContent = 'No stockists in this category yet. Check back soon.'
      listEl.appendChild(empty)
      return
    }
    rows.forEach(function (s) {
      var li = document.createElement('li')
      li.className = 'stk-card'
      li.setAttribute('data-id', s.id)
      li.innerHTML = cardHtml(s)
      listEl.appendChild(li)
    })
  }

  function fitTo(rows) {
    var pts = rows.map(function (s) { return [s.lat, s.lng] })
    if (state.origin) pts.push([state.origin.lat, state.origin.lng])
    if (pts.length > 0) map.fitBounds(pts, { padding: [40, 40], maxZoom: 14 })
  }

  function showError(msg) {
    errEl.textContent = msg
    errEl.hidden = !msg
  }

  function lookup(q) {
    var compact = q.trim().toUpperCase().replace(/\s+/g, '')
    var path = null
    if (FULL_PC.test(compact)) path = '/postcodes/' + encodeURIComponent(compact)
    else if (OUTCODE.test(compact)) path = '/outcodes/' + encodeURIComponent(compact)
    if (!path) return Promise.reject({ kind: 'invalid' })
    return fetch(API + path).then(
      function (res) {
        if (!res.ok) throw { kind: 'notfound' }
        return res.json().then(function (data) {
          if (data.status !== 200 || !data.result) throw { kind: 'notfound' }
          return { lat: data.result.latitude, lng: data.result.longitude }
        })
      },
      function () { throw { kind: 'unavailable' } }
    )
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault()
    showError('')
    lookup(input.value).then(
      function (origin) {
        state.origin = origin
        if (originMarker) originMarker.remove()
        originMarker = L.marker([origin.lat, origin.lng], {
          icon: L.divIcon({ className: '', html: '<div class="stk-origin"></div>', iconSize: [20, 20], iconAnchor: [10, 10] }),
          zIndexOffset: 1000
        }).addTo(map)
        render()
        fitTo(visible().slice()
          .sort(function (a, b) { return miles(origin, a) - miles(origin, b) })
          .slice(0, 5))
      },
      function (err) {
        if (err && err.kind === 'invalid') showError("That doesn't look like a UK postcode. Try the first part, e.g. SW17.")
        else if (err && err.kind === 'notfound') showError("We can't find that postcode. Try the first part, e.g. SW17.")
        else showError('Postcode lookup is temporarily unavailable. You can still browse the full list below.')
      }
    )
  })

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      state.filter = tab.getAttribute('data-filter')
      tabs.forEach(function (t) {
        var active = t === tab
        t.classList.toggle('is-active', active)
        t.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
      render()
      fitTo(visible())
    })
  })

  listEl.addEventListener('click', function (e) {
    if (e.target.closest('a')) return
    var card = e.target.closest('.stk-card')
    if (!card) return
    var m = markersById[card.getAttribute('data-id')]
    if (!m) return
    Array.prototype.forEach.call(listEl.children, function (c) { c.classList.remove('is-active') })
    card.classList.add('is-active')
    var go = function () {
      map.flyTo(m.getLatLng(), Math.max(map.getZoom(), 13), { duration: 0.6 })
      m.openPopup()
    }
    // Inside a cluster? Unfold it first (zooms until the pin is its own marker), then fly + popup.
    if (markerLayer.zoomToShowLayer) markerLayer.zoomToShowLayer(m, go)
    else go()
  })

  fetch(DATA_URL)
    .then(function (res) {
      if (!res.ok) throw new Error('data fetch failed')
      return res.json()
    })
    .then(function (data) {
      state.all = (data.stockists || []).filter(function (s) {
        return typeof s.lat === 'number' && typeof s.lng === 'number'
      })
      render()
      fitTo(state.all)
    })
    .catch(function () {
      showError('Our stockist list would not load. Please refresh the page to try again.')
    })
})()
